import {
  OPEN_ADD_NEW_USER_MODAL,
  CLOSE_ADD_NEW_USER_MODAL,
  GET_ALL_ROLES,
  GET_ALL_ROLES_SUCCESS,
  SET_CHECK_FIELD,
  CREATE_NEW_INTERNAL_USER,
  SET_CREATING_USER_STATE,
  SET_CREATED_USER_STATE,
  GET_ALL_INTERNAL_USERS,
  GET_ALL_INTERNAL_USERS_SUCCESS,
  GET_ACCESS_LOGS,
  GET_ACCESS_LOGS_SUCCESS,
  GETTING_ACCESS_LOGS,
  OPEN_EDIT_INTERNAL_USER_MODAL,
  CLOSE_EDIT_INTERNAL_USER_MODAL,
  UPDATE_INTERNAL_USER,
  UPDATING_INTERNAL_USER,
  SET_CHECK_FIELD_GIVEN_ROLES,
  OPEN_DELETE_INTERNAL_USER_MODAL,
  CLOSE_DELETE_INTERNAL_USER_MODAL,
  DELETING_INTERNAL_USER,
  DELETE_INTERNAL_USER,
  OPEN_RESET_INTERNAL_USER_PASSWORD_MODAL,
  CLOSE_RESET_INTERNAL_USER_PASSWORD_MODAL,
  RESETTING_INTERNAL_USER_PASSWORD,
  RESET_INTERNAL_USER_PASSWORD,
  SET_INTERNAL_USER_INPUT_SEARCH,
  SEARCHING_INTERNAL_USER,
  SEARCH_INTERNAL_USER,
  CLEAR_INTERNAL_USER_INPUT_SEARCH,
  SET_INTERNAL_USER_ROLE_SEARCH,
  CHANGE_INTERNAL_USERS_TABLE_SORT_STATE,
} from 'state/actionTypes';

export const openAddUserModal = () => ({
  type: OPEN_ADD_NEW_USER_MODAL,
});

export const closeAddUserModal = () => ({
  type: CLOSE_ADD_NEW_USER_MODAL,
});

export const getAllRoles = payload => ({
  type: GET_ALL_ROLES,
  payload,
});

export const setCheckField = payload => ({
  type: SET_CHECK_FIELD,
  payload,
});

export const getAllRolesSuccess = payload => {
  return {
    type: GET_ALL_ROLES_SUCCESS,
    payload,
  };
};

export const createNewInternalUser = payload => {
  return {
    type: CREATE_NEW_INTERNAL_USER,
    payload,
  };
};

export const setCreatingUserState = payload => {
  return {
    type: SET_CREATING_USER_STATE,
    payload,
  };
};

export const setCreatedUserState = () => {
  return {
    type: SET_CREATED_USER_STATE,
  };
};

export const getAllInternalUsers = payload => {
  return {
    type: GET_ALL_INTERNAL_USERS,
    payload,
  };
};

export const getAllInternalUsersSuccess = payload => {
  return {
    type: GET_ALL_INTERNAL_USERS_SUCCESS,
    payload,
  };
};

export const getAccessLogs = payload => {
  return {
    type: GET_ACCESS_LOGS,
    payload,
  };
};

export const getAccessLogsSuccess = payload => {
  return {
    type: GET_ACCESS_LOGS_SUCCESS,
    payload,
  };
};

export const gettingAccessLogsAction = payload => {
  return {
    type: GETTING_ACCESS_LOGS,
    payload,
  };
};

export const openEditInternalUserModalWindow = payload => {
  return {
    type: OPEN_EDIT_INTERNAL_USER_MODAL,
    payload,
  };
};

export const closeEditInternalUserModalWindow = () => {
  return {
    type: CLOSE_EDIT_INTERNAL_USER_MODAL,
  };
};

export const updateInternalUser = payload => {
  return {
    type: UPDATE_INTERNAL_USER,
    payload,
  };
};

export const updatingInternalUser = payload => {
  return {
    type: UPDATING_INTERNAL_USER,
    payload,
  };
};

export const setCheckFieldGivenRoles = payload => {
  return {
    type: SET_CHECK_FIELD_GIVEN_ROLES,
    payload,
  };
};

export const openDeleteInternalUserModalWindow = payload => {
  return {
    type: OPEN_DELETE_INTERNAL_USER_MODAL,
    payload,
  };
};

export const closeDeleteInternalUserModalWindow = () => {
  return {
    type: CLOSE_DELETE_INTERNAL_USER_MODAL,
  };
};

export const deletingInternalUser = payload => {
  return {
    type: DELETING_INTERNAL_USER,
    payload,
  };
};

export const deleteInternalUser = payload => {
  return {
    type: DELETE_INTERNAL_USER,
    payload,
  };
};

export const openResetInternalUserPasswordModal = payload => {
  return {
    type: OPEN_RESET_INTERNAL_USER_PASSWORD_MODAL,
    payload,
  };
};

export const closeResetInternalUserPasswordModal = () => {
  return {
    type: CLOSE_RESET_INTERNAL_USER_PASSWORD_MODAL,
  };
};

export const resettingInternalUserPassword = payload => {
  return {
    type: RESETTING_INTERNAL_USER_PASSWORD,
    payload,
  };
};

export const resetInternalUserPassword = payload => {
  return {
    type: RESET_INTERNAL_USER_PASSWORD,
    payload,
  };
};

export const setInternalUserInputSearch = payload => {
  return {
    type: SET_INTERNAL_USER_INPUT_SEARCH,
    payload,
  };
};

export const searchingInternalUser = payload => {
  return {
    type: SEARCHING_INTERNAL_USER,
    payload,
  };
};

export const searchInternalUser = payload => {
  return {
    type: SEARCH_INTERNAL_USER,
    payload,
  };
};

export const clearInternalUserInputSearch = payload => {
  return {
    type: CLEAR_INTERNAL_USER_INPUT_SEARCH,
    payload,
  };
};

export const setInternalUserRoleSearch = payload => {
  return {
    type: SET_INTERNAL_USER_ROLE_SEARCH,
    payload,
  };
};

export const changeInternalUsersTableSortState = payload => {
  return {
    type: CHANGE_INTERNAL_USERS_TABLE_SORT_STATE,
    payload,
  };
};
